import { render, staticRenderFns } from "./BrandBanner.vue?vue&type=template&id=e39f783a&scoped=true&"
import script from "./BrandBanner.vue?vue&type=script&lang=js&"
export * from "./BrandBanner.vue?vue&type=script&lang=js&"
import style0 from "./BrandBanner.vue?vue&type=style&index=0&id=e39f783a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39f783a",
  null
  
)

export default component.exports